export default [
  {
    text: 'Помещение в торговом комплексе',
    value: 'shoppingMall',
  },
  {
    text: 'Street retail',
    value: 'streetRetail',
  },
];
